let initialState= []

export function productDBReducer(state = null, action) {
    switch (action.type) {
        case "ADD_TO_PRODUCTDB":
            return action.payload;
        default:
            return state;
    }
}